import React from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment/locale/es';
import { jsUcfirst } from '../utils/helpers.js';

const MejorAgrupacion = props => {
	return (
		<div className={`mejor mejor-${props.agrupaciones[props.ides].cat}`}>
			<Link to={`/agrupaciones/${props.agrupaciones[props.ides].ide}`}>
				<p className="nombre">{props.agrupaciones[props.ides].nom}</p>
				<p className="fecha">
					<Moment filter={jsUcfirst} format="dddd D	MMM" locale="es">
						{props.agrupaciones[props.ides][`${props.fase}sesion`]}
					</Moment>
				</p>
			</Link>
			<p className="puntos">
				{props.agrupaciones[props.ides][`${props.fase}tot`]}
			</p>
		</div>
	);
};

export default MejorAgrupacion;



// WEBPACK FOOTER //
// ./src/components/mejorAgrupacion.js